'use client';

type OrdergrooveMsiLoaderOptions = {
    onLoad: () => void;
    onError: () => void;
    isOgCookieSet: boolean;
    scriptUrl: string;
};

/**
 * Legacy loader: injects Ordergroove script directly in DOM.
 * Returns optional cleanup for effect teardown.
 */
export const createOrdergrooveLoaderLegacy = ({
    onLoad,
    onError,
    isOgCookieSet,
    scriptUrl,
}: OrdergrooveMsiLoaderOptions) => {
    // If the script is already present, consider it loaded regardless of cookie state
    const existing = document.querySelector(`script[src="${scriptUrl}"]`);
    if (existing) {
        onLoad();
        return;
    }

    // If the cookie is not set, do not load the script
    // https://developer.ordergroove.com/docs/subscription-manager-tagging-and-authentication
    if (!isOgCookieSet) {
        return;
    }

    const script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;
    script.onload = () => onLoad();
    script.onerror = () => onError();
    document.body.appendChild(script);

    return () => {
        if (!script.parentNode) return;
        script.remove();
    };
};
